"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class ThirdPartyIntegration extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'thirdPartyIntegration';
        this._integrationMetaData = initParams.integration_meta_data;
    }
    set integrationMetaData(value) {
        console.error('Do not set objects this way');
    }
    get integrationMetaData() {
        return this._integrationMetaData;
    }
}
exports.default = ThirdPartyIntegration;
//# sourceMappingURL=thirdPartyIntegration.js.map